<template>
  <div class="user_lnb">
    <div class="bg" v-show="isShow">
        <img
            :src="bgStyle === 'type1' ? type1 : bgStyle === 'type2' ? type2 : type3" 
            alt=""
        >
    </div>
    <ul class="nav_title">
        <li>홈 <b-icon icon="chevron-right"></b-icon></li>
        <li 
            v-for="(nav, idx) in navTitle" 
            :key="idx">{{ nav }}
            <b-icon icon="chevron-right"></b-icon>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
    name:'UserLnb',
    props: {
        navTitle: {
            type: Array,
            default: () => []
        },
        bgStyle: {
            type: String,
            default: 'type1'
        },
        isShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            type1: require('@/assets/img/layout/lnb_01.png'),
            type2: require('@/assets/img/layout/lnb_02.png'),
            type3: require('@/assets/img/layout/lnb_03.png'),
        }
    }
}
</script>

<style>

</style>